import br from './br'
const i18n = require('vanilla-i18n')
i18n.setTranslate(br, 'br')
i18n.setDefaultLanguage('br')
